import { mapGetters /*, mapActions */ } from 'vuex'
import { axiosGet } from '../../../../axios/axios.js'
import { Invcomet } from '../../../../comet/comet.js'
import { EventBus } from '../../../../EventBus/EventBus.js'

export const medicineMain = {
  data: function () {
    return {
      listWorkShiftMedical: null,
      showMedicalShedule: { inScoreboard: false, inMedicalPage: false },
      showInBlock: true,
      medicalSchedule: [],
      timeChangeList: 0,
      employeeMedicCheck: { time: 0, employeeId: null },
      pageUrlName: '',
      widthResize: 247,
      fontSize: 1.7,
      clientWidth: 1236,
      classResize: 'q-py-xs',
      isMedicalTablo: false
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    })
  },
  watch: {
    pageUrlName: function (name) {
      this.getWorkShift()
    }
  },
  beforeDestroy () {
    EventBus.$off('get-medical-shedule', this.getMedicalShedule)
    EventBus.$off('get-color-text', this.getColorText)
    EventBus.$off('set-show-medical-shedule', this.setShow)
    EventBus.$emit('set-show-medical-shedule', { show: false, page: 'medicine' })
    EventBus.$emit('set-show-medical-shedule', { show: false, page: 'medicine-tablo' })
    EventBus.$off('action-event-type-comet', this.actionEventTypeComet)
    EventBus.$off('update-result-medical-test', this.updateResultMedicalTest)
  },
  created: function () {
    // this.getWorkShift()
    this.isMedicalTablo = this.user.isMedicalTablo
    EventBus.$on('get-medical-shedule', this.getMedicalShedule)
    EventBus.$on('get-color-text', this.getColorText)
    EventBus.$on('set-show-medical-shedule', this.setShow)
    EventBus.$on('action-event-type-comet', this.actionEventTypeComet)
    EventBus.$on('update-result-medical-test', this.updateResultMedicalTest)
  },
  methods: {
    onMedicalRegistrationJournalChanges: function (user) {},
    setShow: function (params) {
      if (params.page == 'medicine-tablo') {
        this.showMedicalShedule.inScoreboard = params.show
        this.showMedicalShedule.inMedicalPage = false
      } else if (params.page == 'medicine') {
        this.showMedicalShedule.inScoreboard = false
        this.showMedicalShedule.inMedicalPage = params.show
      } else {
        this.showMedicalShedule.inScoreboard = false
        this.showMedicalShedule.inMedicalPage = false
      }
    },
    setComet: function () {
      this.showInBlock = false
      const listTypeMedicComet = [
        'employee_wicket_in',
        'employee_wicket_out',
        'employee_medical_result',
        'employee_medic_check',
        'medicalRegistrationJournalChanges'
      ]
      const comet = new Invcomet({
        onSubscribe: function (subscribeId, listenerId) {
          comet.addListener({
            onEvent: (event) => {
              if (listTypeMedicComet.includes(event.type)) {
                EventBus.$emit('action-event-type-comet', event)
              }
              if (event.type == 'user.kicked') {
                EventBus.$emit('action-user-kicked-comet', event)
              }
            }
          })
        },
        onUnsubscribe: function () {},
        onError: function (errorId) {}
      })
      return comet
    },
    actionEventTypeComet: function (event) {
      const user = this.$store.getters.getUser
      const routeName = this.pageUrlName // $route.name
      const that = this
      if (!['scoreboard', 'medical', 'medicine', 'medicine-tablo'].includes(routeName)) {
        return
      }
      this.$nextTick(() => {
        if (['scoreboard', 'medicine-tablo'].includes(routeName) && !this.showMedicalShedule.inScoreboard) {
          if (!(event.type === 'medicalRegistrationJournalChanges')) {
            return
          }
        } else if (['medical', 'medicine'].includes(routeName) && !this.showMedicalShedule.inMedicalPage) {
          return
        }
        let employee = {}
        let indexEmployee = -1
        if (event.type === 'employee_wicket_in' && this.showMedicalShedule.inScoreboard) {
          employee = this.medicalSchedule.find(item => item.employeeId == event.employeeid && (!item.isAtWork || !item.medicalExaminationResult))
          if (employee !== undefined && Object.keys(employee).length) {
            indexEmployee = this.medicalSchedule.findIndex(item => item.employeeId == event.employeeid && (!item.isAtWork || !item.medicalExaminationResult))
            employee.isAtWork = true
            employee.employeeEntrance = !employee.medicalExaminationResult ? 'entrance' : 'isAtWork'
            employee.class = that.getColorText({ state: employee.medicalExaminationResult, location: employee.employeeEntrance })
            this.medicalSchedule.splice(indexEmployee, 1, employee)
            this.timeChangeList = (new Date()).getTime()
            EventBus.$emit('show-employees-pass', event.employeeid)
          }
        } else if (event.type === 'employee_wicket_out' && this.showMedicalShedule.inScoreboard) {
          employee = this.medicalSchedule.find(item => item.employeeId == event.employeeid && !item.medicalExaminationResult)
          if (employee !== undefined && Object.keys(employee).length) {
            indexEmployee = this.medicalSchedule.findIndex(item => item.employeeId == event.employeeid && !item.medicalExaminationResult)
            employee.isAtWork = false
            employee.employeeEntrance = false
            employee.class = that.getColorText({ state: employee.medicalExaminationResult, location: '' })
            this.medicalSchedule.splice(indexEmployee, 1, employee)
            this.timeChangeList = (new Date()).getTime()
          }
        } else if (event.type === 'employee_medical_result' &&
                   (this.showMedicalShedule.inScoreboard || this.showMedicalShedule.inMedicalPage)) {
          employee = this.medicalSchedule.find(item => item.employeeId == event.employeeid)
          if (employee !== undefined && Object.keys(employee).length) {
            this.updateResultMedicalTest({
              id: employee.id,
              result: event.result.code,
              inspectionTime: event.time
            })
          }
        } else if (user.isMedic &&
                   event.type === 'employee_medic_check' &&
                   this.showMedicalShedule.inMedicalPage &&
                   user.skudId == event.deviceId) {
          // console.log('MEDIC CHECK', event)
          this.employeeMedicCheck = { time: new Date().getTime(), employeeId: event.employeeid }
        } else if (event.type === 'medicalRegistrationJournalChanges') {
          this.onMedicalRegistrationJournalChanges(user)
        }
      })
    },
    updateResultMedicalTest: function (record) {
      let employee = null
      const employeePostTrip = this.medicalSchedule.find(item => item.id == record.id && item.medicalExaminationKind == 'postTrip')
      const employeePreTrip = this.medicalSchedule.find(item => item.id == record.id && item.medicalExaminationKind == 'preTrip')
      if (employeePostTrip !== undefined) {
        if (employeePreTrip !== undefined) {
          employee = !employeePostTrip.medicalExaminationResult ? employeePostTrip : employeePreTrip
        } else {
          employee = employeePostTrip
        }
      } else {
        employee = employeePreTrip
      }
      // employee = this.medicalSchedule.find(item => item.id == record.id)
      if (employee !== undefined) {
        const kind = employee.medicalExaminationKind
        const indexEmployee = this.medicalSchedule.findIndex(item => item.id == record.id && item.medicalExaminationKind == kind)
        employee.medicalExaminationResult = record.result
        employee.isAtWork = true
        employee.inspectionTime = record.inspectionTime
        employee.class = this.getColorText({ state: employee.medicalExaminationResult, location: employee.isAtWork })
        this.medicalSchedule.splice(indexEmployee, 1, employee)
        this.timeChangeList = (new Date()).getTime()
      }
    },
    sortName: function (arrEmployee) {
      return arrEmployee.sort((previous, next) => previous.employeeFIO > next.employeeFIO ? 1 : -1)
    },
    sortTime: function (arrWorkShif) {
      return arrWorkShif.sort((previous, next) => previous.startTime > next.startTime ? 1 : -1)
    },
    getWorkShift: function () {
      const date = new Date()
      const urlName = '/service/delta/journal/regularMedicalSchedule/getWorkShift?date=' + date.getTime()
      return axiosGet({
        url: urlName,
        onSuccess: (response) => {
          let listWorkShiftMedical = response.data.result
          listWorkShiftMedical = listWorkShiftMedical.filter(workShift => workShift.role === 'medical')
          this.listWorkShiftMedical = this.sortTime(listWorkShiftMedical)
          return Promise.resolve()
        },
        onFailure: (response) => {
          this.listWorkShiftMedical = null
          this.$q.notify({
            type: 'negative',
            message: response.message ? response.message : 'Ошибка получения смен медосмотра',
            progress: true,
            timeout: 10000
          })
          return Promise.reject(Error('Ошибка получения смен медосмотра'))
        }
      })
    },
    getMedicalShedule: function (show) {
      const that = this
      let medicalSchedule = []
      let employee = {}
      let indexEmployee = -1
      let employeeLocation = ''
      let signUpdate = false
      let signRebuild = !that.medicalSchedule.length
      const showMedicalShedule = this.showMedicalShedule.inScoreboard
      this.regularMedicalSchedule(show).then(result => {
        const copyMedicalSchedule = that.medicalSchedule.map(item => ({ ...item }))
        if (result.length) {
          if (!showMedicalShedule) {
            medicalSchedule = result
          } else {
            medicalSchedule = result.sort((previous, next) => (previous.employeeFIO > next.employeeFIO) ? 1
              : (previous.employeeFIO === next.employeeFIO)
                ? (previous.medicalExaminationKind < next.medicalExaminationKind ? 1 : -1) : -1)
          }
          medicalSchedule.forEach(function (object, i) {
            employeeLocation = object.isAtWork ? 'isAtWork' : ''
            employee = copyMedicalSchedule.find(item => item.employeeId == object.employeeId && item.medicalExaminationKind == object.medicalExaminationKind)
            if (employee === undefined) {
              object.class = that.getColorText({ state: object.medicalExaminationResult, location: employeeLocation })
              const postAndPreTrip = !(copyMedicalSchedule.find(item => item.employeeId == object.employeeId &&
                                                                   item.medicalExaminationKind !== object.medicalExaminationKind) === undefined)
              if (!showMedicalShedule ||
                 (showMedicalShedule && (!postAndPreTrip ||
                                        (postAndPreTrip && object.medicalExaminationKind == 'preTrip')))) {
                copyMedicalSchedule.push(object)
                signRebuild = true
              }
              if (postAndPreTrip) {
                const indexPostTrip = copyMedicalSchedule.findIndex(item => item.employeeId == object.employeeId &&
                  item.medicalExaminationKind == 'postTrip')
                const employeePostTrip = copyMedicalSchedule.find(item => item.employeeId == object.employeeId &&
                    item.medicalExaminationKind == 'postTrip')
                // employeePostTrip.postTrip = true
                if (employeePostTrip !== undefined) {
                  that.$set(employeePostTrip, 'postTrip', true)
                  copyMedicalSchedule.splice(indexPostTrip, 1, employeePostTrip)
                }
              }
            } else {
              if (object.medicalExaminationResult !== employee.medicalExaminationResult ||
                  object.isAtWork !== employee.isAtWork ||
                  object.inspectionTime !== employee.inspectionTime) {
                signUpdate = true
                indexEmployee = copyMedicalSchedule.findIndex(item => item.employeeId == object.employeeId && item.medicalExaminationKind == object.medicalExaminationKind)
                employee.medicalExaminationResult = object.medicalExaminationResult
                employee.isAtWork = object.isAtWork
                employee.inspectionTime = object.inspectionTime
                // employee.medicalExaminationKind = object.medicalExaminationKind
                employee.class = that.getColorText({ state: object.medicalExaminationResult, location: employeeLocation })
                copyMedicalSchedule.splice(indexEmployee, 1, employee)
              }
            }
            employee = null
          })
          if (signRebuild) {
            that.medicalSchedule = that.rebuildList(copyMedicalSchedule)
          } else if (signUpdate) {
            that.medicalSchedule = copyMedicalSchedule
          }
        } else {
          signRebuild = true
          that.medicalSchedule = []
        }
        if (signRebuild || signUpdate) {
          that.timeChangeList = (new Date()).getTime()
        }
      })
    },
    regularMedicalSchedule: function (show) {
      if (!show) {
        return new Promise((resolve, reject) => resolve([]))
      } else {
        const now = new Date()
        const urlName = '/service/delta/journal/regularMedicalSchedule/list?date=' + now.getTime() + '&currentOrNext=true'
        return axiosGet({
          url: urlName,
          onSuccess: (response) => {
            const result = response.data.result
            return Promise.resolve(result)
          },
          onFailure: (response) => {
            this.$q.notify({
              type: 'negative',
              message: response.message ? response.message : 'Ошибка загрузки списка для прохождения медосмотра',
              progress: true,
              timeout: 10000
            })
            return Promise.reject(Error('Ошибка загрузки списка для прохождения медосмотра'))
          }
        })
      }
    },
    getColorText: function (object) {
      let color = 'grey'
      switch (object.state) {
        case 'success':
          color = 'positive'
          break
        case 'alcohol':
        case 'pressure':
        case 'health':
          color = 'negative'
          break
        default:
          if (object.location == 'isAtWork') {
            color = 'dark'
          } else if (object.location == 'entrance') {
            color = 'light-blue '
          }
          break
      }
      return ' text-' + color
    },
    rebuildList: function (result) {
      if (!result || !result.length) {
        return []
      }
      const pageMedicine = this.pageUrlName == 'medicine'
      const pageMedicineTablo = this.pageUrlName == 'medicine-tablo'
      if (pageMedicineTablo) {
        const countColumn = Math.ceil(result.length / 25)
        const countColumnFix = Math.ceil((countColumn + (this.isMedicalTablo ? 5 : 6)) * 5 / 10)
        const widthResize = Math.trunc((this.clientWidth - 8) / countColumnFix) // ? 240 + window.screenTop
        const fontSize = (this.isMedicalTablo ? 1.4 : 1.2) + Math.round((6 - countColumn) * 10 / 18) / 10
        if (this.isMedicalTablo) {
          this.classResize = result.length <= 105 ? ' q-py-sm ' : ' q-py-xs '
        } else {
          if (result.length > 96 && window.screenTop) {
            this.classResize = ''
          } else {
            this.classResize = countColumnFix <= 3 ? ' q-py-sm ' : ' q-py-xs '
          }
        }

        let arrReturn = []
        const arrSort = this.sortName(result)
        const arrMedium = []
        let lenPart = arrSort.length % countColumnFix
        const len = parseInt(arrSort.length / countColumnFix)
        let col = 0
        let k = 0
        for (let i = 0; i < countColumnFix; i++) {
          arrMedium[i] = []
          col = len + (lenPart > 0 ? 1 : 0)
          for (let j = 0; j < col; j++) {
            arrMedium[i][j] = arrSort[k++]
          }
          lenPart--
        }
        arrReturn = []
        for (let i = 0; i < Math.ceil(arrSort.length / countColumnFix); i++) {
          arrMedium.forEach((row) => {
            for (let j = 0; j < row.length; j++) {
              arrReturn.push(row[j])
              row.splice(0, 1)
              break
            }
          })
        }
        this.widthResize = widthResize
        this.fontSize = fontSize
        return arrReturn
      } else if (pageMedicine) {
        return this.sortName(result)
      } else {
        return []
      }
    }
  }
}
